import React, {useEffect} from "react"
import "./verifyIcon.scss";


const VerifyIcon = (props: {className: string, animate: boolean}) => {
    useEffect(() => {
        // GET LENGTH OF SVG ANIMATION
        // const circle = document.querySelectorAll<SVGPathElement>('#verifyIcon circle')
        // const check = document.querySelectorAll<SVGPathElement>('#verifyIcon polyline')
        // for(let i = 0; i < circle.length; i++) {
        //     console.log('CIRCLE I', circle[i].getTotalLength())
        // }
        // for(let i = 0; i < check.length; i++) {
        //   console.log('CHECK P', check[i].getTotalLength())
        // }
      });

    const animateClass = props.animate ? 'animateIcon' : ''
    return (
        <svg version="1.1" id="verifyIcon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" className={`icon ${animateClass} ${props.className}`}>
            <circle fill="none" stroke="#000000" strokeWidth="10" strokeMiterlimit="10" cx="256" cy="256" r="247.81"/>
            <polyline fill="none" stroke="#000000" strokeWidth="18" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="116.3,246 215,345.88 395.7,166.12 "/>
        </svg>
    )
}

export default VerifyIcon
